import { treaty } from '@elysiajs/eden';
import type { Api } from '@/api';

const client = treaty<Api>(window.location.origin, {
  throwHttpError: true,
});

export const apiClient = client.api.v1;

export const unwrap = <T>(data: T | null): T => {
  if (!data) {
    throw {
      success: false,
      message: 'Ops! Algo deu errado. Tente novamente mais tarde.',
    };
  }

  return data;
};
